import React from 'react'
import useSearch from '../../../context/search/useSearch'

const SearchAmendedResults: React.FC = () => {
  const { searchTerm, autoCorrectedQuery, activeTab, productSearchResult, searchResultsArticles, searchResultsPages } = useSearch()

  const isAutocorrected = autoCorrectedQuery !== null &&
  autoCorrectedQuery !== searchTerm;

  const isSecondaryList = productSearchResult?.isSecondaryList === true;


  if (!isAutocorrected && !isSecondaryList) {
    return null;
  }

  if (activeTab === 'products' && productSearchResult?.total === 0) {
    return null;
  }
  if (activeTab === 'blogs' && searchResultsArticles.length === 0) {
    return null;
  }
  if (activeTab === 'pages' && searchResultsPages.length === 0) {
    return null;
  }



  // Show secondary list message if using secondary list
  if (isSecondaryList) {
    return (
      <div className="search-amended-results">
        <div>0 results for &quot;{searchTerm}&quot;. Here are some related results.</div>
      </div>
    )
  }

  // Show autocorrected message
  return (
    <div className="search-amended-results">
      <div>Sorry we couldn&apos;t find &quot;{searchTerm}&quot;</div>
      <div>Showing results for &quot;{autoCorrectedQuery}&quot;</div>
    </div>
  )
}

export default SearchAmendedResults